var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "__btn_input" }, [
      "password" === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: {
              autofocus: "",
              placeholder: _vm.$t("create.input"),
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.password)
                ? _vm._i(_vm.password, null) > -1
                : _vm.password
            },
            on: {
              change: function($event) {
                var $$a = _vm.password,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.password = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.password = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.password = $$c
                }
              }
            }
          })
        : "password" === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: {
              autofocus: "",
              placeholder: _vm.$t("create.input"),
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.password, null) },
            on: {
              change: function($event) {
                _vm.password = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            attrs: {
              autofocus: "",
              placeholder: _vm.$t("create.input"),
              type: "password"
            },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "__btn __btn_all_in __pointer",
        on: { click: _vm.unlock }
      },
      [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLoading,
                expression: "!isLoading"
              }
            ]
          },
          [_vm._v("UNLOCK")]
        ),
        _vm._v(" "),
        _c("loading", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          attrs: { loadingType: "dot" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }